import React, { lazy, useEffect } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import AuthLayout from '../JoshKera/Auth/Index';
const ForgotPass = lazy(() => import('../JoshKera/Auth/ForgotPassword'));
const ResetPassword = lazy(() => import('../JoshKera/Auth/ResetPassword'));
const Login = lazy(() => import('../JoshKera/Auth/SignIn'));
const SignUp = lazy(() => import('../JoshKera/Auth/Signup'));
// const FbLogin = lazy(() => import('../JoshKera/Auth/FbSignIn'));
// const FbSignUp = lazy(() => import('../JoshKera/Auth/FbSignup'));
// const NotFound = lazy(() => import('../pages/404'));

const AuthRoot = () => {
  const navigate = useNavigate();

  useEffect(() => navigate('/'));
};

const FrontendRoutes = React.memo(() => {
  return (
    <Routes>
      <Route index element={<Login />} />
      <Route path="forgot" element={<ForgotPass />} />
      <Route path="reset-password/:token" element={<ResetPassword />} />
      <Route path="register" element={<SignUp />} />
      {/* <Route path="fbRegister" element={<FbSignUp />} /> */}
      {/* <Route path="fbSignIn" element={<FbLogin />} /> */}
      {/* <Route path="*" element={<NotFound />} /> */}
      <Route path="*" element={<AuthRoot />} />
    </Routes>
  );
});

export default AuthLayout(FrontendRoutes);
